import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFeatureFlags, useLogger } from '@cko/dashboard-shared';

import { FeatureFlagId } from '../../config/shared/enums/featureFlagIds';
import { getHeapAPI } from './HeapAPI';
import { useIdentifyUser } from './useIdentifier';
import { useUpdateHeapTokenProperties } from './useUpdateHeapTokenProperties';
import { useUpdateHeapClientProperties } from './useUpdateHeapClientProperties';

const TIMEOUT_MS = 15000;

export const useHeap = () => {
  const logger = useLogger();

  const { getFeatureFlag } = useFeatureFlags();
  const isHeapErrorReportingEnabled = getFeatureFlag(FeatureFlagId.ENABLE_HEAP_ERROR_REPORTING);

  const trackHeapError = useCallback((name: string, error: Error) => {
    if (!isHeapErrorReportingEnabled) {
      return;
    }
    logger.error(name, error);
  }, []);

  const [isReady, setIsReady] = useState<boolean>(false);

  const heapApi = useMemo(() => getHeapAPI(trackHeapError), [trackHeapError]);

  useIdentifyUser(isReady, heapApi);
  useUpdateHeapTokenProperties(isReady, heapApi);
  useUpdateHeapClientProperties(isReady, heapApi);

  useEffect(() => {
    heapApi.isHeapReady(TIMEOUT_MS).then(setIsReady);
  }, [heapApi]);
};
